import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import App from './task';
import './task/style.css';

ReactDOM.render(
	<App />,
	document.getElementById('root')
);
